import { Typography } from "@mui/material"
import { useIsDesktop } from "common/MediaQueries"
import { mapDataToFitCarousel } from "common/mapDataToFitCarousel"
import useRedirectIfPreviousComponentsAreNotSelected from "common/useRedirectIfPreviousComponentsAreNotSelected"
import ColorsCarousel from "components/carModelPage/sections/exterior/enterence/ColorsCarousel"
import { useLocation } from "react-router-dom"
import { useAppDispatch, useTypedSelector } from "store"
import styled from "styled-components"
import Colors from "../color/Colors"
import { setSelectedUpholstery } from "./upholsterySlice"

const StyledHeadline = styled(Typography).attrs({
  variant: "h2",
  // component: "h1",
  tabIndex: 0,
})`
  ${(p) => p.theme.breakpoints.down("sm")} {
    text-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
  }
`

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-bottom: 30px;
  }
`
const StyledMobileWrapper = styled.div`
  width: 100%;
`

const UpholsterySidebar = () => {
  useRedirectIfPreviousComponentsAreNotSelected()
  const dispatch = useAppDispatch()
  const isDesktop = useIsDesktop()
  const { upholsteries, selectedUpholsteryCode } = useTypedSelector(
    (state) => state.upholstery
  )
  const { pathname } = useLocation()
  const upholsteriesData = mapDataToFitCarousel(upholsteries, "thumbnailImage")

  const selectedUpholsteryIndex: number = upholsteries.reduce((a, b, i) => {
    if (b?.details?.code === selectedUpholsteryCode) return i
    return a
  }, 0)

  return (
    <>
      {isDesktop ? (
        <>
          <StyledHeadline id="upholsteriesHeadline">בחירת ריפוד</StyledHeadline>
          <StyledWrapper>
            <Colors
              type="upholstery"
              data={upholsteriesData}
              selectedItem={selectedUpholsteryCode}
              handleColorChange={(code) => {
                dispatch(setSelectedUpholstery(code))
              }}
            />
          </StyledWrapper>
        </>
      ) : (
        <StyledMobileWrapper>
          <ColorsCarousel
            selectedColorIndex={selectedUpholsteryIndex}
            colorsData={upholsteriesData}
            handleColorChange={(index) => {
              dispatch(setSelectedUpholstery(upholsteriesData[index]?.code))
            }}
            loop={false}
            textPosition="bottom"
            showExtraPrice
            pathname={pathname}
          />
        </StyledMobileWrapper>
      )}
    </>
  )
}

export default UpholsterySidebar
